<template>
    <v-facebook-login
        :app-id="facebook.appId"
        :button-style="{margin:'0 auto'}"
        @connect="facebookLogin"
        :login-options="facebook.loginOptions"
        @logout="facebookLogout"
        @sdk-init="facebookInit"
        :version="facebook.version"
    ></v-facebook-login>
</template>

<script>
import axios from "axios";
import vFacebookLogin from "vue-facebook-login-component"

export default {
    name: 'FacebookLogin',

    components: {vFacebookLogin},

    props: {
        facebook: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            facebookSDK: null,
        }
    },

    methods: {
        facebookInit({FB: sdk}) {
            this.facebookSDK = sdk;
        },
        facebookLogin() {
            axios
                .post(this.urlPrefix + '/users/social-api/facebook.json', {token: this.facebookSDK.getAccessToken()})
                .then(r => {
                    this.$emit('authenticated', r.data.user);

                    if (!this.redirect.length) {
                        return;
                    }

                    if (this.redirect === 'reload') {
                        window.location.reload();

                        return;
                    }

                    window.location.href = this.redirect;
                });
        },
        facebookLogout() {
            axios
                .post(this.urlPrefix + '/logout.json')
                .then(r => {
                    this.$emit('unauthenticated', r.data.user);

                    if (!this.redirect.length) {
                        return;
                    }

                    if (this.redirect === 'reload') {
                        window.location.reload();

                        return;
                    }

                    window.location.href = this.redirect;
                });
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Users/LoginOrSignup/FacebookLogin.vue